const PREFIX = 'NOTIF_';

export const SET_ALERT = PREFIX + 'SET_ALERT';